export default __webpack_public_path__ + "4edc4635cbf74ea2b7dc18149d84644b.jpg";